module.exports = __webpack_public_path__ + "static/media/align_top_dark.d727a080.svg";